<script setup lang="ts">
import { CarrierPageData } from '@/page/domain/CarrierPageData';

defineProps<{
  carrierData: Partial<CarrierPageData>;
}>();
</script>

<template>
  <div class="w-full bg-sky-50 py-16">
    <div class="flex flex-1 flex-col items-center max-w-7xl mx-auto relative px-6">
      <h2 :class="carrierData.textDirection ? carrierData.textDirection : 'text-center'" class="mb-6 text-2xl lg:text-3xl" v-html="carrierData.title"></h2>
      <div :class="carrierData.textDirection ? carrierData.textDirection : 'text-center'" v-html="carrierData.content"></div>
    </div>
  </div>
</template>
